"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardPanel = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

require("./Dashboards.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Dashboard Panel
var DashboardPanel = function DashboardPanel(_ref) {
  var title = _ref.title,
      headerLink = _ref.headerLink,
      headerLinkTitle = _ref.headerLinkTitle,
      trkAction = _ref.trkAction,
      containerized = _ref.containerized,
      classNames = _ref.classNames,
      maxHeight = _ref.maxHeight,
      children = _ref.children;
  var containerizedClassName = containerized ? 'containerized' : '';
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "DashboardPanel ".concat(containerizedClassName, " ").concat(classNames),
    style: {
      maxHeight: maxHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "container-title ".concat(containerizedClassName),
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "title",
    color: _atoms.Color.Black,
    type: _atoms.Label.Type.Title4
  }, title), headerLink && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    tag: "a",
    href: headerLink,
    trkAction: trkAction
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    color: _atoms.Color.Trace,
    type: _atoms.Label.Type.Body
  }, headerLinkTitle))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "container-content ".concat(containerizedClassName)
  }, children));
};

exports.DashboardPanel = DashboardPanel;
DashboardPanel.defaultProps = {
  containerized: false,
  maxHeight: 'none'
};